// extracted by mini-css-extract-plugin
export default {"elementsContracts":"Documentation_elementsContracts__D6f5v","modal":"Documentation_modal__QzUQJ"};